import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { API } from "aws-amplify";
import User from "./User";
import AuthGmail from "./AuthGmail";


import "./Settings.css";


export default class Settings extends Component {
  constructor(props) {
    super(props);

    this.file = null;

    this.state = {
      isLoading: null,
    };
  }

  
  validateForm() {
    return this.state.content.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.setState({ isLoading: true });
    try {
      await this.signupAuthorize();
      this.props.history.push("/");
    } catch (e) {
      alert(e);
      this.setState({ isLoading: false });
    }
  }
  signupAuthorize() {
    return API.post("Gmail", "/authorizeUri");
  }

  render() {
    return (
      <div className="SignupGmail">
        <PageHeader>Settings</PageHeader>
          <AuthGmail/>
          <User/>
      </div>
    );
  }

  

}


// WEBPACK FOOTER //
// ./src/containers/settings/Settings.js